<template>
  <v-app light>
    <change-password v-if="firstAccess"></change-password>

    <div v-if="!firstAccess">
      <v-navigation-drawer dense app v-model="drawer">
        <v-img :aspect-ratio="16 / 9" src="./assets/img/portal.jpg">
          <v-row align="end" class="lightbox white--text pa-2 fill-height">
            <v-col>
              <div class="body-1">{{ fullName }}</div>
            </v-col>
          </v-row>
        </v-img>

        <v-list>
          <v-list-item v-for="item in optionsMenu" :key="item.title" :to="{ name: item.pathName, params: companyName }">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $tc('entity.' + item.title, 1) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar dense app>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" light></v-app-bar-nav-icon>
        <v-toolbar-title class="pt-2">
          <img class="logo-toolbar" src="./assets/img/logo-aliaddo-02.svg" alt="Mi Nomina" />
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-menu offset-y left transition="slide-x-transition">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item :to="{ name: 'MyAccount' }">
              <v-icon>person</v-icon>
              <v-list-item-title>{{ $t('entity.myAccount') }}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'person' }">
              <v-icon>{{ optionsMenu[5].icon }}</v-icon>
              <v-list-item-title>{{ $tc('entity.' + optionsMenu[5].title, 1) }}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'logout' }">
              <v-icon>power_settings_new</v-icon>
              <v-list-item-title>{{ $t('entity.logout') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-content>
        <v-container fluid>
          <v-slide-y-transition mode="out-in">
            <router-view></router-view>
          </v-slide-y-transition>
        </v-container>
      </v-content>

      <v-footer app class="footer-bottom">
        <span>&copy; 2020</span>
      </v-footer>
    </div>
  </v-app>
</template>

<script>
import { menus } from './components/_list/menus'
import { getToken } from './assets/js/shared/utils.js'
export default {
  data() {
    return {
      firstAccess: false,
      person: '',
      optionsMenu: menus,
      drawer: true,
      email: '',
      fullName: '',
      logo: '',
      companyName: '',
      companyNameParam: ''
    }
  },
  methods: {
    getCompanyParam() {
      getToken().companyPortalName
    },
    getPerson() {
      this.loading = true
      this.$http.get('common/people/' + getToken().personId).then(
        (response) => {
          // console.log('person > ', response.body);
          this.person = response.body
          // ------------------ OJO, CAMBIAR ANTES DE DESPLEGAR ---------------
          this.firstAccess = this.person.personAppEmployeeIsFirstAccess
          // this.firstAccess = false
        },
        (response) => {
          console.error('Error getPerson() > ', response)
        }
      )
    }
  },
  mounted() {
    this.getCompanyParam()
    this.getPerson()
    if (getToken()) {
      this.email = getToken().email
      this.fullName = getToken().prsName
      // console.log(this.email);
      // console.log(this.fullName);
      this.$http.get('common/companies/authenticated').then(
        (response) => {
          // console.log("Person >>> ", response.body);
          this.logo = response.body.companyLogo
          // console.log("logo>>> ", this.logo);
          this.companyName = response.body.companyName
        },
        (response) => {
          console.error('Error mounted getPerson() > ', response)
        }
      )
    }
    if (window.localStorage) {
      var x = Boolean(localStorage.getItem('firstLoad'))
      if (!x) {
        // if not reloaded once, then set firstload to true
        localStorage.setItem('firstLoad', true)
        // reload the webpage using reload() method
        window.location.reload()
      } else {
        localStorage.removeItem('firstLoad')
      }
    }
  }
}
</script>

<style>
@media only screen and (min-width: 960px) {
  .content-padding {
    padding: 10px 71px;
  }
}

.content-padding {
  padding: 10px;
}

/* @media (max-width: 610px) {
  .logo-toolbar {
    height: 40px !important;
    margin-top: 9px !important;
  }
} */

.tooltip__content {
  background: #000000;
  border-radius: 0px;
  color: #fff;
  font-size: 12px;
  display: inline-block;
  padding: 5px 8px;
  position: absolute;
  text-transform: initial;
  -webkit-transition: 0.15s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.15s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: auto;
  -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.logo-toolbar {
  height: 30px;
  margin-top: 8px;
}

.company-logo {
  /* border: 3px solid white; */
  width: 67px !important;
  height: 67px !important;
  background-size: contain;
  background-position: center;
}

.extended-drawer {
  padding-top: 15px !important;
  height: 168px;
}

.footer-bottom {
  width: 100%;
  /* position: absolute; */
  bottom: 0px;
  left: 0px;
}

.progress-linear {
  margin: 0;
}

.swal2-popup {
  font-family: 'Open Sans', sans-serif !important;
}
</style>
